import { z } from "zod";

import { zOutSchema } from "./common";

import { Response } from "~/shared/api";

const zRes200 = Response.Schema.zSuccessful(200, z.array(zOutSchema));
const zRes404 = Response.Schema.zUnsuccessful(404);

const zRes = Response.Schema.zAggregated([zRes200, zRes404]);
type Res = z.infer<typeof zRes>;

export { zRes };
export type { Res };
